export default __webpack_public_path__ + "static/media/BlueTick.826f1bc3.svg";